__turbopack_context__.v({
  "gallery-container": "f3M7nG_gallery-container",
  "load-more-button": "f3M7nG_load-more-button",
  "pdp-badge": "f3M7nG_pdp-badge",
  "pdp-badge-low-stock": "f3M7nG_pdp-badge-low-stock",
  "pdp-slider": "f3M7nG_pdp-slider",
  "pdp-wrapper": "f3M7nG_pdp-wrapper",
  "video-player": "f3M7nG_video-player",
});
